import React from 'react'

export default function SearchBar({ setSearch, setType }) {

   return (
      <div className="row py-3">
         <div className="col-6">
            <div className="input-group">
               <input type="search" onChange={e => setSearch(e.target.value)} className="form-control" placeholder="search..." />
            </div>
         </div>
         <div className="col-6 col-md-3">
            <div className="input-group">
               <div className="input-group-prepend">
                  <label className="input-group-text fs-6" htmlFor="type"> Type</label>
               </div>
               <select onChange={e => setType(e.target.value)} defaultValue={''} className="custom-select " id="category">
                  <option value={''}>All...</option>
                  <option value="first">First</option>
                  <option value="second">Second</option>
                  <option value="dessert">Dessert</option>
               </select>
            </div>
         </div>
      </div>
   )
}
